export enum TicketStatusEnum {
	IN_QUEUE = 1,
	IN_PROCESS = 2,
	CLOSED = 3,
	REOPENED = 4,
	EXPIRED = 5,
}